import type { EvergladesProductsApiSuccess, IntentResult, Product, SearchContext } from '@shared/types/types.ts';
import { isContextIntent, isSimilarIntent } from '@shared/types/types.ts';
import { GALLERY_PORTRAIT } from '@tilelist/domain/composition/BracketLayout.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';

/**
 *
 */
const DEFAULT_PRODUCT_TYPE = 'AS' as const;

/**
 *
 */
const SIMILAR_PRODUCTS_LIMIT = 120;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function composeFallbackTileListPage(response: EvergladesProductsApiSuccess): TileListPageLayout {
    const searchContext = getContext(response);

    const context = {
        rule: response.rule ?? '',
        searchContext,
        layout: GALLERY_PORTRAIT,
    };

    const page = {
        sortiertnach: '',
        o: '',
        l: GALLERY_PORTRAIT.layoutParam,
        c: '',
    };

    const pagination = {
        currentPage: 1,
        currentOffset: 0,
        lastPage: 1,
    };

    const tileListItems = composeTileListItems(response.intents);

    return {
        tileListItems,
        tracking: {},
        page,
        isFallback: true,
        pagination,
        rankedCount: 0,
        sponsoredCount: 0,
        displayCount: 0,
        comparisonId: undefined,
        context,
    };
}

/**
 *
 *
 */
function composeTileListItems(intents: IntentResult[]): ProductItem[] {
    const similarIntent = intents.find(isSimilarIntent);

    if (!similarIntent || similarIntent.products.length === 0) {
        return [];
    }

    /*                            */
    const limitedProducts = similarIntent.products.slice(0, SIMILAR_PRODUCTS_LIMIT);

    /*                                                                               */
    return limitedProducts.map((product, index) =>
        toProductItem({
            product,
            interleavedIndex: index,
            startingOffset: 0,
            originPosition: index,
        }),
    );
}

/**
 *
 */
function getContext(response: EvergladesProductsApiSuccess): SearchContext {
    const context = response.intents.find(isContextIntent) || {};
    return {
        rule: response.rule,
        ...context,
    };
}

/**
 *
 *
 *
 *
 *
 *
 */
function toProductItem({
    product,
    interleavedIndex,
    startingOffset,
    originPosition,
}: {
    product: Product;
    interleavedIndex: number;
    startingOffset: number;
    originPosition: number;
}): ProductItem {
    return {
        product,
        variations: [],
        type: DEFAULT_PRODUCT_TYPE,
        localListPosition: interleavedIndex + 1,
        actualListPosition: startingOffset + interleavedIndex + 1,
        originPosition,
    };
}
